import { AuthService } from './../../service/auth.service';
import { Component, OnInit } from '@angular/core';
import { getDefaultService } from 'selenium-webdriver/chrome';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
user:any;
role:any =false;
  constructor(public auth: AuthService) { }

  ngOnInit() {
  this.user = this.auth.user
    //  this.auth.getuser().then(user => {
  //   console.log(user);
  //   this.user = user;
  // },
  // error => {
  //   console.log(error);
  // });
}
}



// WEBPACK FOOTER //
// ./src/app/side-nav/header/header.component.ts